import type { Job, CreateJobIntakeCommand } from "../model/Job";
import type { JobService } from "../port/JobService";

export class CreateJobIntake {
  constructor(
    private readonly service: JobService
  ) {}

  execute(cmd: CreateJobIntakeCommand): Promise<Job> {
    return this.service.createIntake(cmd);
  }
}
